module.exports.MixpanelAddPlaylist = /* @ngInject */ function MixpanelAddPlaylist($rootScope, MixpanelEventsListener) {
    return function (orig, playlist, subjectsToAdd) {

        let groupPattern =  new RegExp('/group/([0-9]+)');
        let group = window.location.href.match(groupPattern);
        let groupId = null;
        if (null !== group && undefined !== group && group.length > 0) {
            groupId = group[1];
        }

        let tracks = [];
        subjectsToAdd.forEach((subject) => {
            tracks.push({
                trackName: subject.track.name,
                trackFixationID: subject.fixationId,
                trackVersion: (undefined !== subject.track.version_names) ? subject.track.version_names.join(', ') : null,
                albumName: subject.album.name,
                albumCode: subject.album.code,
                label: subject.album.label.name,
                labelGroup: subject.album.label.labelGroup.name,
                duration: subject.track.duration,
            });
        });
        let data = {
            orig: orig,
            playlistName: playlist.name,
            playlistGroup: groupId,
            trackCount: tracks.length,
            tracks: tracks
        };

        $rootScope.$emit(MixpanelEventsListener.MIXPANEL_PLAYLIST_ADD, data);
    };
};


// WEBPACK FOOTER //
// ./src/PlayApp/AppBundle/Resources/js/angular/services/MixpanelAddPlaylist.js